<div class="mobile-capture-page">
  <!-- Header -->
  <div class="mobile-header">
    <div class="header-content">
      <div class="header-main">
        <h1><i class="pi pi-camera"></i> Captura de Imagen</h1>
        <p class="session-info">Sesión: {{sessionId}}</p>
      </div>
      <div class="header-actions">
        <p-button
          *ngIf="sessionValidated && selectedField"
          icon="pi pi-question-circle"
          (onClick)="toggleInstructions()"
          styleClass="p-button-text p-button-rounded"
          pTooltip="Instrucciones">
        </p-button>
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <div class="error-message" *ngIf="errorMessage">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{errorMessage}}</span>
    <div class="error-help" *ngIf="errorMessage.includes('HTTPS') || errorMessage.includes('seguridad')">
      <p><strong>💡 Solución:</strong> Asegúrate de acceder usando HTTPS (https://) en lugar de HTTP.</p>
    </div>
    <div class="error-help" *ngIf="errorMessage.includes('terminada')">
      <p><strong>ℹ️ Información:</strong> La sesión ha sido cerrada desde la computadora. Esta ventana se cerrará automáticamente.</p>
    </div>
  </div>



  <!-- Loading Section -->
  <div class="loading-section" *ngIf="!sessionValidated && !errorMessage && status.includes('Conectando') || status.includes('Esperando')">
    <div class="loading-content">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: #007bff;"></i>
      <h3>{{status}}</h3>
      <p>Conectando con la computadora</p>
    </div>
  </div>

  <!-- Field Selector -->
  <div class="field-selector" *ngIf="sessionValidated && showFieldSelector && !selectedField && !errorMessage.includes('terminada')">
    <div class="selector-panel">
      <div class="panel-header">
        <h4><i class="pi pi-list"></i> Selecciona un Campo</h4>
        <p>Elige dónde quieres enviar la imagen</p>
      </div>

      <div class="fields-list">
        <div
          *ngFor="let field of remoteFields"
          class="field-option"
          (click)="selectField(field)">
          <div class="field-icon">
            <i class="pi pi-file" *ngIf="field.accept.includes('image')"></i>
            <i class="pi pi-file-pdf" *ngIf="field.accept.includes('pdf')"></i>
            <i class="pi pi-file-edit" *ngIf="field.accept.includes('doc')"></i>
            <i class="pi pi-file" *ngIf="!field.accept.includes('image') && !field.accept.includes('pdf') && !field.accept.includes('doc')"></i>
          </div>
          <div class="field-info">
            <h5>{{field.label}}</h5>
            <p *ngIf="field.description">{{field.description}}</p>
            <small>
              {{field.multiple ? 'Múltiples archivos' : 'Un solo archivo'}} |
              {{field.maxSize ? (field.maxSize / 1024 / 1024) + 'MB' : 'Sin límite'}}
            </small>
          </div>
          <div class="field-arrow">
            <i class="pi pi-chevron-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content" *ngIf="sessionValidated && selectedField && !errorMessage.includes('terminada')">
    <!-- Camera View -->
    <div class="camera-section" *ngIf="showWebcam && !capturedImage">
      <div class="camera-panel">
        <div class="panel-header">
          <div class="header-left">
            <div class="camera-status" *ngIf="sessionValidated && selectedField && status !== 'Listo para capturar'">
              <i class="pi pi-spin pi-spinner" *ngIf="status.includes('Inicializando') || status.includes('Enviando') || status.includes('Validando') || status.includes('Esperando')"></i>
              <i class="pi pi-check-circle" *ngIf="status.includes('enviada')" style="color: #28a745;"></i>
              <i class="pi pi-image" *ngIf="capturedImage && !isCapturing" style="color: #2196f3;"></i>
              <span>{{status}}</span>
            </div>
          </div>
          <div class="header-actions">
            <p-button
              *ngIf="sessionValidated && selectedField && remoteFields.length > 1"
              label="Cambiar Campo"
              icon="pi pi-refresh"
              (onClick)="changeField()"
              styleClass="p-button-text p-button-sm">
            </p-button>
          </div>
        </div>
        <div class="camera-container">
          <webcam-capture-form
            [title]="'Captura de Imagen'"
            [description]="'Usa tu cámara para capturar una imagen'"
            [width]="getCameraWidth()"
            [height]="getCameraHeight()"
            [showPreview]="false"
            [showCaptureButton]="true"
            [captureButtonMode]="'floating'"
            [showRetakeButton]="false"
            [autoStartCamera]="true"
            (photoCaptured)="handleImage($event)"
            (cameraError)="handleInitError($event)">
          </webcam-capture-form>
        </div>

        <!-- Camera Controls -->
        <div class="camera-controls">
          <p-button
            label="Seleccionar Archivo"
            icon="pi pi-folder-open"
            (onClick)="selectFile()"
            styleClass="p-button-primary">
          </p-button>
        </div>

        <!-- Hidden File Input -->
        <input
          #fileInput
          type="file"
          [accept]="selectedField.accept || '*'"
          [multiple]="selectedField.multiple || false"
          (change)="onFileSelected($event)"
          style="display: none;">
      </div>
    </div>

    <!-- Captured Image Preview -->
    <div class="captured-section" *ngIf="capturedImage">
      <div class="captured-panel">
        <div class="panel-header">
          <h4>Imagen Capturada</h4>
        </div>
        <div class="image-preview">
          <img [src]="capturedImage.base64Data"
               alt="Imagen capturada"
               class="captured-image">
        </div>

        <div class="image-actions">
          <p-button
            label="Enviar Imagen"
            icon="pi pi-send"
            (onClick)="sendImage()"
            styleClass="p-button-success p-button-lg"
            [disabled]="isCapturing"
            [loading]="isCapturing">
          </p-button>

          <p-button
            label="Nueva Foto"
            icon="pi pi-refresh"
            (onClick)="retakePhoto()"
            styleClass="p-button-secondary">
          </p-button>
        </div>

      </div>
    </div>

    <!-- Mensaje de Validación (se muestra independientemente del origen del archivo) -->
    <div class="validation-message" *ngIf="showValidationMessage">
      <span>{{validationMessage}}</span>
    </div>

    <!-- Instructions Panel (Hidden by default) -->
    <div class="instructions-overlay" *ngIf="showInstructions" (click)="toggleInstructions()">
      <div class="instructions-panel" (click)="$event.stopPropagation()">
        <div class="panel-header">
          <h4><i class="pi pi-lightbulb"></i> Instrucciones</h4>
          <p-button
            icon="pi pi-times"
            (onClick)="toggleInstructions()"
            styleClass="p-button-text p-button-rounded p-button-danger">
          </p-button>
        </div>
        <div class="instructions-content">
          <ol>
            <li><strong>Para tomar foto:</strong> Posiciona el objeto y presiona "Capturar Foto"</li>
            <li><strong>Para seleccionar archivo:</strong> Presiona "Seleccionar Archivo" y elige desde tu dispositivo</li>
            <li>Revisa el archivo seleccionado</li>
            <li>Presiona "Enviar" para completar</li>
          </ol>

          <div class="tips">
            <h5><i class="pi pi-lightbulb"></i> Consejos:</h5>
            <ul>
              <li><strong>Fotos:</strong> Mantén el dispositivo estable y asegúrate de buena iluminación</li>
              <li><strong>Archivos:</strong> Verifica que el tipo de archivo sea compatible con el campo seleccionado</li>
              <li><strong>Tipos permitidos:</strong> {{selectedField.accept || 'Todos los tipos'}}</li>
              <li><strong>Tamaño máximo:</strong> {{selectedField.maxSize ? ((selectedField.maxSize || 0) / 1024 / 1024) + 'MB' : 'Sin límite'}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>
